import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { SpinnerService } from 'app/services/spinner.service';
import { AssistenzaService } from 'app/services/assistenza.service';
import { UserService } from 'app/services/user/user.service';
import { AssistenzaFE, AssistenzaStatus, ASSISTENZA_STATUS, PersonNameFE } from 'app/components/models/assistenzaData';
import { AuthService } from 'app/services/auth.service';

@Component({
  selector: 'app-manage-assistenza',
  templateUrl: './manage-assistenza.component.html',
  styleUrls: ['./manage-assistenza.component.css'],
})

export class ManageAssistenzaComponent implements OnInit {

  submitted = false;
  error = false;
  file_error = false;
  file_message = '';
  success = false;
  dataJSON: any;
  assistenzaList: AssistenzaFE[];
  parentAssistenza: AssistenzaFE;
  assistenzaForm: FormGroup;
  personData: PersonNameFE;
  picture = 'assets/img/hrwe-user.jpg';
  parentSubject: string;
  parentUsername: string;
  parentMessage: string;
  parentInsertDateTime: string;
  parentPicture: string;
  parentAttachment: any;
  adminUser: Boolean = false;
  statusList: AssistenzaStatus[];
  parentStatus: string;
  uploadedFile: any;
  base64Content: any;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private assistenzaService: AssistenzaService,
    private spinner: SpinnerService,
    private commonUtilService: CommonUtilService,
    private userService: UserService,
    private auth: AuthService) {

    this.spinner.start();

    this.adminUser = this.auth.isAdmin();

  }

  ngOnInit() {

    this.spinner.start();

    this.statusList = ASSISTENZA_STATUS;

    this.commonUtilService.translateLang("HRWE.PAGE_TITLE.MANAGE_ASSISTANZA");

    const id = this.route.snapshot.paramMap.get('id');

    this.assistenzaForm = this.createAssistenzaFormBuilder(this.formBuilder);

    this.getParentAssistenza(id);
  }

  createAssistenzaFormBuilder(formBuilder: FormBuilder) {
    if (this.adminUser) {
      return formBuilder.group({
        message: ['', [Validators.required]],
        attachment: [''],
        status: [this.parentStatus]
      });
    } else {
      return formBuilder.group({
        message: ['', [Validators.required]],
        attachment: [''],
      });
    }
  }

  getAssistenzaList(id) {
    this.spinner.start();
    this.assistenzaService.getAssistenzaListByThreadId(id).subscribe(data => {

      let asList = data;
      for (let xx in asList) {
        
        this.userService.getRoleByUser(asList[xx].userId).subscribe(roleData => {
          if (roleData.role == CommonUtilService.ROLE_ADMIN) {
            asList[xx].leftContent = 'd-none';
            asList[xx].rightContent = '';
            asList[xx].userName = 'Amministratore';
          } else if (roleData.role == CommonUtilService.ROLE_USER) {
            asList[xx].leftContent = '';
            asList[xx].rightContent = 'd-none';

            this.userService.getPersonalDetailByUserEmail(asList[xx].userId).subscribe(data => {
              asList[xx].picture = data && data.picture ? data.picture : this.picture;
              asList[xx].userName = data.firstName + " " + data.lastName;
            });
          }
        });
      }
      this.assistenzaList = asList;
      this.spinner.stop();
    });
  }

  getParentAssistenza(id) {

    this.assistenzaService.getParentAssistenza(id).subscribe(data => {
      /* console.log(data); */
      this.parentAssistenza = data;
      //console.log("Parent assistenza " + this.parentAssistenza);
      this.parentInsertDateTime = data.insertDateTime;
      this.parentSubject = data.subject;
      this.parentMessage = data.message;
      this.parentAttachment = data.attachment;
      this.parentStatus = data.status;
      this.userService.getPersonalDetailByUserEmail(this.parentAssistenza.userId).subscribe(dataUser => {
        this.parentAssistenza.picture = dataUser && dataUser.picture ? dataUser.picture : this.picture;
        this.parentPicture = dataUser && dataUser.picture ? dataUser.picture : this.picture;
        this.parentAssistenza.userName = dataUser.firstName + " " + dataUser.lastName;
        this.parentUsername = dataUser.firstName + " " + dataUser.lastName;

        this.getAssistenzaList(id);
        this.spinner.stop();
      });
    });
  }

  get f() { return this.assistenzaForm.controls; }

  get val() { return this.assistenzaForm.value; }

  onSubmit() {

    this.submitted = true;
    // stop here if form is invalid
    if (this.assistenzaForm.invalid) {
      this.commonUtilService.findInvalidControls(this.assistenzaForm);
      return;
    }

    this.spinner.start();

    this.dataJSON = {
      subject: this.parentAssistenza.subject,
      message: this.val.message,
      attachment: {
        fileName: this.uploadedFile && this.uploadedFile.name ? this.uploadedFile.name : null,
        type: this.uploadedFile && this.uploadedFile.type ? this.uploadedFile.type : null,
        size: this.uploadedFile && this.uploadedFile.size ? this.uploadedFile.size : null,
        extension: this.uploadedFile && this.uploadedFile.name ? this.uploadedFile.name.split('.').pop(): null,
        domain: null,
        userId: null,
        base64: this.base64Content,
        code: null,
        message: null
      },
      threadId: this.parentAssistenza.threadId,
      isParent: 'false',
      status: this.adminUser ? this.val.status : this.parentStatus
    }

    console.log(this.dataJSON);
    this.assistenzaService.addAssistenza(this.dataJSON).subscribe(data => {
      this.success = true;
      location.reload();
      this.spinner.stop();
    },
      err => {
        this.error = true;
        this.spinner.stop();
      }
    );
  }

  goBack() {
    this.router.navigate(['/help']);
  }

  onFileChange(event, field, extension?) {
    const reader = new FileReader();
    if (event.target.files.length > 0) {
      this.file_error = false;
      this.file_message = '';
      this.uploadedFile = event.target.files[0];
      if (!extension || this.commonUtilService.enabledExtension(this.uploadedFile, extension)) {
        reader.readAsDataURL(this.uploadedFile);
        reader.onload = () => {
          let kb = this.uploadedFile.size / 1024;
          let mb = kb / 1024;
          let sizeParsed = parseFloat(mb.toString());
          if (sizeParsed > CommonUtilService.LIMIT_SIZE_MB) {
            this.file_error = true;
            this.assistenzaForm.get(field).setValue(undefined);
            return;
          }
          //console.log(this.assistenzaForm);
          this.base64Content = this.commonUtilService.getBase64FromFile(reader.result);
          this.assistenzaForm.get(field).setValue({
            name: this.uploadedFile.name,
            filetype: this.uploadedFile.type,
            fileBinary: reader.result
          });
        };
      } else {
        this.file_message = CommonUtilService.FILE_BAD_EXTENSION;
        this.file_error = true;
        this.assistenzaForm.get(field).setValue(undefined);
        return;
      }
    }
  }

  getAttachmentFile(name, fileBinary) {
    this.commonUtilService.downloadFile(name, fileBinary, true);
    return false;
  }

}